import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const UniversityService = {
  getList: async ({ showInactive = true, destinationCountryId }) => {
    const params = new URLSearchParams({
      ...(showInactive !== null &&
        showInactive !== undefined && { showInactive: showInactive }),
      ...(destinationCountryId && { destinationCountryId }),
    });
    const response = await apiService.get(`/universities?${params.toString()}`);
    console.log(response);
    return response.data;
  },
  create: async (data) => {
    const response = await apiService.post("/universities", data);
    return response.data;
  },
  createIntell: async (id, data) => {
    const response = await apiService.post(
      `/universityintellsection/${id}`,
      data,
    );
    return response.data;
  },
  updateIntell: async (id, updateData) => {
    try {
      const response = await apiService.put(
        `/universityintellsection/${id}`,
        updateData,
      );
      return response.data;
    } catch (error) {
      console.error("Error updating Universities", error);
      throw error;
    }
  },
  deleteIntell: async (id) => {
    const response = await apiService.delete(`/universityintellsection/${id}`);
    return response.data;
  },
  getbyId: async (id) => {
    const response = await apiService.get(`/universities/${id}`);
    console.log(response.data);
    return response.data;
  },

  getIntellbyId: async (id) => {
    const response = await apiService.get(
      `/universityintellsection/by-university/${id}`,
    );
    console.log(response.data);
    return response.data;
  },
  getIntellbySlug: async (id) => {
    const response = await apiService.get(
      `/universityintellsection/by-university/${id}`,
    );
    console.log(response.data);
    return response.data;
  },
  update: async (id, updateData) => {
    try {
      const response = await apiService.put(`/universities/${id}`, updateData);
      return response.data;
    } catch (error) {
      console.error("Error updating Universities", error);
      throw error;
    }
  },
  delete: async (id) => {
    const response = await apiService.delete(`/universities/${id}`);
    return response.data;
  },
  checkSlug: async (data) => {
    const response = await apiService.post("/universities/check-slug", data);
    return response.data;
  },
};
export default UniversityService;
